import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/react"

export default () => (
  <StaticQuery
    query={graphql`
      query imageChirurgienEnQuery {
        file(relativePath: { eq: "portrait-bandeau-roure.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        fluid={data.file.childImageSharp.fluid}
        alt="Dr Philippe Roure, Hand and upper limb surgeon in Paris."
        css={css`
          width: 100%;
          transform: translateY(85px);
          z-index: -1;
          margin-top: -85px;
          @media (max-width: 1024px) {
            transform: none;
            margin-top: 0;
          }
        `}
      />
    )}
  />
)
